"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuPlanner = void 0;
const apolloComponents_1 = require("../generated/apolloComponents");
const common_1 = require("@saffron/common");
const ymdToDate_1 = require("../utils/ymdToDate");
const dateToNextWeek_1 = require("../utils/dateToNextWeek");
const dateToStartEndStrings_1 = require("../utils/dateToStartEndStrings");
const standardDateFormat_1 = require("../utils/standardDateFormat");
const client_1 = require("@apollo/client");
const dayjs_1 = __importDefault(require("dayjs"));
const menuSectionColors = [
    "#824028",
    "#C6A15B",
    "#D13C1E",
    "#447588",
    "#9AA52E",
    "#E9834C",
    "#8A2A32",
    "#50A0C3",
    "#E5BB4B",
    "#B3560B",
    "#586C50",
    "#9CB3C5",
    "#61120E",
];
const MONDAY = 1;
exports.useMenuPlanner = ({ year, month, day, date: initialDate, dateSize = "week", menuItemsFetchPolicy = "cache-and-network", validStartOfWeek = MONDAY, endDate, startDate, menuItemsSkip, }) => {
    const { data: msd, loading: msLoading, refetch: msRefetch, networkStatus: msNetworkStatus, } = apolloComponents_1.useMenuSectionsQuery({
        notifyOnNetworkStatusChange: true,
    });
    const menuSections = msd && msd.menuSections
        ? common_1.sortBy(msd.menuSections, "position").map((x, i) => (Object.assign({ color: menuSectionColors[i] }, x)))
        : [];
    const date = initialDate || ymdToDate_1.ymdToDate(year, month, day);
    let variables = { startDate: "", endDate: "" };
    if (startDate && endDate) {
        variables.startDate = startDate;
        variables.endDate = endDate;
    }
    else if (dateSize === "week") {
        variables = dateToNextWeek_1.dateToNextWeek(date, validStartOfWeek);
    }
    else if (dateSize === "month") {
        variables = dateToStartEndStrings_1.dateToStartEndMonth(date, validStartOfWeek);
    }
    else if (dateSize === "day") {
        variables = {
            startDate: date.format(standardDateFormat_1.standardDateFormat),
            endDate: date.format(standardDateFormat_1.standardDateFormat),
        };
    }
    const { data: mid, loading: miLoading, refetch: miRefetch, networkStatus: miNetworkStatus, } = apolloComponents_1.useMenuPlannerQuery({
        variables,
        fetchPolicy: menuItemsFetchPolicy,
        notifyOnNetworkStatusChange: true,
        skip: menuItemsSkip,
        nextFetchPolicy: "cache-first",
    });
    const menuItemsOrNotes = mid && mid.menuPlanner ? mid.menuPlanner : [];
    const menuItemOrNote = {};
    const menuSectionIdMap = {};
    menuItemsOrNotes.forEach(mi => {
        if (!mi.menuSectionId) {
            return;
        }
        if (mi.date in menuItemOrNote) {
            if (mi.menuSectionId in menuItemOrNote[mi.date]) {
                menuItemOrNote[mi.date][mi.menuSectionId].push(mi);
            }
            else {
                menuItemOrNote[mi.date][mi.menuSectionId] = [mi];
            }
        }
        else {
            menuItemOrNote[mi.date] = {
                [mi.menuSectionId]: [mi],
            };
        }
        menuSectionIdMap[mi.menuSectionId] = true;
    });
    const startingDate = dayjs_1.default(variables.startDate);
    const numDays = (startDate && endDate) || dateSize === "month"
        ? Math.abs(startingDate.diff(dayjs_1.default(variables.endDate), "day")) + 1
        : 7;
    const menuDays = [];
    for (let i = 0; i < numDays; i += 1) {
        const dt = i === 0 ? startingDate : menuDays[i - 1].dt.add(1, "day");
        const dtKey = dt.format(standardDateFormat_1.standardDateFormat);
        menuDays.push({
            isCurrentMonth: dt.month() === date.month(),
            dtKey,
            dt,
            menuItemOrNoteSectionMap: menuItemOrNote[dtKey] || {},
        });
    }
    return {
        date,
        menuSections,
        menuDays,
        dateSize,
        loading: miLoading || msLoading,
        menuItemsOrNotes,
        menuPlannerQueryVariables: variables,
        refetch: () => {
            msRefetch();
            miRefetch();
        },
        refetching: msNetworkStatus === client_1.NetworkStatus.refetch ||
            miNetworkStatus === client_1.NetworkStatus.refetch,
    };
};
//# sourceMappingURL=useMenuPlanner.js.map